import { createFileRoute, useParams } from '@tanstack/react-router';
import { importIsInvalid } from '@/services/db/collection/entity';
import { useCollection } from '@/services/db/collection/queries';
import { Redirect } from '@/services/router/redirect';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';
import { LazyPage } from './-route-layouts';

/**
 * Picks the child route from the collection's import state. It renders under the authenticated
 * layout rather than redirecting from `beforeLoad`, because the collection request needs the
 * account's region, which auth resolves.
 */
function CollectionDetailIndexRoute() {
  const { collectionId } = useParams({ strict: false });
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const { data: collection } = useCollection({ id: collectionId ?? '' });

  if (importIsInvalid(collection)) {
    return <Redirect to="/workspaces/$workspaceId/collections" params={{ workspaceId }} replace={true} />;
  }

  const route = collection.importing
    ? '/workspaces/$workspaceId/collections/$collectionId/importing'
    : '/workspaces/$workspaceId/collections/$collectionId/data';

  return <Redirect to={route} params={{ workspaceId, collectionId: collection.id }} replace={true} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/$collectionId/')({
  component: () => (
    <LazyPage>
      <CollectionDetailIndexRoute />
    </LazyPage>
  ),
});
